import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    bbShortenString,
    mapObject
} from "../../../util/bbHelpers";
import {

    fetchCustomers, fetchInsiderAttackOptions,

} from "../../../actions";
import PropTypes from "prop-types";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import Tooltip from "@material-ui/core/Tooltip";
import BBDataTable from "../tables/BBDataTable";
import RequestAttackButton from "../controllers/RequestAttackButton";
// import BBIconOption from "../../../assets/bbCustomIcons/BBIconOption";
// import BBIconMouseTargetAoD from "../../../assets/bbCustomIcons/BBIconMouseTargetAoD";
// import BBIconSpreadInternalAssessment from "../../../assets/bbCustomIcons/BBIconSpreadInternalAssessment";
import {renderCellExpand} from "../tables/DataGridRenderCellExpand";
import BBExternalLink from "../accents/BBExternalLink";

const TableContainer = (props) => {

    const {customerId} = props;

  /**************************/
  /*Setup State and Dispatch*/
  /**************************/
  const {customers, loadingCustomers, customerInView,} = useSelector(({customer}) => customer);
    const {attackPackages, loadingAttackPackages,} = useSelector(({insider}) => insider);
  const dispatch = useDispatch();
  //select the customer from the store if it exists, based on the props customerId
  // const customer = customers ? customerId ? customers[customerId] : customerInView ? customers[customerInView] : null : null;
    const customer = customers && customerInView ? customers[customerInView] : null;

    //from the customer, pull the ACTIVE target data if it exists

  useEffect(() => {

      if (!customers && !loadingCustomers) {
          // console.log("Customers is empty, fetching.")
          dispatch(fetchCustomers());
      } else if (customer && attackPackages === null && !loadingAttackPackages) {
          // console.log("vectors is empty, fetching vectors for customerId = ", customer.CustomerId);
          dispatch(fetchInsiderAttackOptions());
      }

    // console.groupEnd()
  }, [dispatch, customers, attackPackages, loadingAttackPackages, customerId, customerInView, customer, loadingCustomers ]);

  /**************************/
  /*End Setup State and Dispatch*/
  /**************************/

    const title = <div className={""}>
        Insider Attack Options <Tooltip title={"Use this menu to order Insider Attacks.  Once ordered, requested attacks will be provisioned by our attack infrastructure and then queued in the Insider Attack Status Log for your use. "}>
            <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>
        </Tooltip>
    </div>;

  const userTableHeadings = [
      //{ field: 'customerId', headerName: 'CID', hide: true, flex : 1, sortable: true, type: 'string', },
      // { field: 'id', headerName: 'Package ID', hide: true, flex : 1, sortable: true, type: 'string', },
      { field: 'attackTypeName', headerName: 'Attack Type', hide: true, flex:0.75, sortable: true, type: 'string', renderCell: (params) => (

          renderCellExpand(params, <Tooltip title={`${params.value} | ${params.row.attackTypeDescription}`}>
                    <span>
                        {params.value}
                    </span>
              </Tooltip>
          ))},
      // { field: 'attackTypeId', headerName: 'Type', renderHeader: (params) => <Tooltip title={"Attack Type"}><span><BBIconOption/></span></Tooltip>, hide: false, width:50, sortable: true, type: 'string', renderCell: (params) => (
      //         <Tooltip title={`${params.row.attackTypeName} | ${params.row.attackTypeDescription}`}>
      //               <span>
      //                   {params.value === 0 //0 is AoD
      //                       ? <BBIconMouseTargetAoD/>
      //                       : <BBIconSpreadInternalAssessment/>
      //                   }
      //               </span>
      //         </Tooltip>
      //     ),
      //     cellClassName: (params: GridCellClassParams) => params.row.wasRowJustAdded ? "text-electric-blue-light" : "",},

      { field: 'name', headerName: 'Name', hide: false, flex:1.5, sortable: true, type: 'string', renderCell: (params) => (
              renderCellExpand(params, params.row.url ?
                  <BBExternalLink href={params.row.url}
                                             tipText={`${params.value} | Learn more about how to use this attack at BreachBits.com.`}>{params.value}</BBExternalLink>

                  :<Tooltip title={`${params.value} | ${params.row.description}`}>
                    <span>
                        {params.value}
                    </span>
                      </Tooltip>

              )
          )
          },
      { field: 'description', headerName: 'Description', hide: false, flex : 2.2, sortable: false, type: 'string', renderCell: renderCellExpand},
      // { field: 'description', headerName: 'Description', hide: false, flex : 2.2, sortable: false, type: 'string', renderCell: (params) => (
      //         <Tooltip title={`${params.value}}`}>
      //               <span>
      //                   {params.value}
      //               </span>
      //         </Tooltip>
      //     )},
      { field: 'os', headerName: 'OS', sortable: true, type: 'string', width: 75, renderCell: (params) => (
              <Tooltip title={`Target Operating System: ${params.value} | ${params.row.osDetailsDescription}`}>
                    <span>
                        {params.row.osDetailsLogo && <img style={{height: 18}} src={params.row.osDetailsLogo} alt={`${bbShortenString(params.value, 25, true)}`} />}
                        {(!params.row.osDetailsLogo) && params.value}
                    </span>
              </Tooltip>
          )},
      { field: 'toolkitName', headerName: 'Toolkit', hide: false, flex:1.1, sortable: true, type: 'string', renderCell: (params) => (
              renderCellExpand(params, <Tooltip title={`${params.value} | ${params.row.toolkitDescriptionLong}`}>
                    <span>
                        {params.value}
                    </span>
              </Tooltip>)
          )},
      { field: 'actions', headerName: 'Actions', hide: false, width:100, sortable: false, type: 'string',
          renderCell: (params) => (
                <RequestAttackButton
                    customerId={customer.CustomerId}
                    attackPackageId={params.row.id}
                />
    )}

  ];

    //peel the state data into a form the dataTable can read
  const tableData = attackPackages ? mapObject(attackPackages, (key, attackPackage) => {
    return (
        {
            // "0cda06e3-13be-4ae0-86e6-d81cfee54b64": {
            //     "AttackPackageId": "0cda06e3-13be-4ae0-86e6-d81cfee54b64",
            //     "Platform": {
            //         "Id": 0,
            //         "Name": "Windows",
            //         "Description": "Microsoft's Windows Operating System",
            //         "Logo": "https://resources.breachbits.co/logos/windows.png"
            //     },
            //     "Toolkit": {
            //         "Id": 1,
            //         "Name": "Koadic",
            //         "Description Short": "Windows Post-Exploitation Agent",
            //         "Description Long": "Koadic, or COM Command & Control, is a Windows post-exploitation agent similar to other penetration testing tools such as Meterpreter and Powershell Empire. The major difference is that Koadic does most of its operations using Windows Script Host (a.k.a. JScript/VBScript), with compatibility in the core to support a default installation of Windows 2000 with no service packs (and potentially even versions of NT4) all the way through Windows 10."
            //     },
            //     "Name": "Koadic Single Host Discovery",
            //     "Description": "This Koadic attack uses the Windows utility mshta.exe to execute, then performs several discovery techniques to survey the victim host.",
            //     "Execution Technique Id": "WE0004",
            //     "Persistence Technique Id": null,
            //     "Privilege Escalation Technique Id": null,
            //     "Defense Evasion Technique Id": null,
            //     "Credential Access Technique Id": null,
            //     "Discovery Technique Id": "WD0001,WD0006,WD0002,WD0009K",
            //     "Lateral Movement Technique Id": null,
            //     "Data Collection Technique Id": null,
            //     "Exfiltration Technique Id": "WEX001",
            //     "Command and Control Technique Id": "WC2001",
            //     "Attack Package Detail": "{\"0cda06e3-13be-4ae0-86e6-d81cfee54b64\":{\"0\":{\"tacticId\":\"WD0001\",\"status\":null,\"eventId\":null,\"taskId\":null,\"taskedSession\":null},\"1\":{\"tacticId\":\"WD0006\",\"status\":null,\"eventId\":null,\"taskId\":null,\"taskedSession\":null},\"2\":{\"tacticId\":\"WD0002\",\"status\":null,\"eventId\":null,\"taskId\":null,\"taskedSession\":null},\"3\":{\"tacticId\":\"WD0009K\",\"status\":null,\"eventId\":null,\"taskId\":null,\"taskedSession\":null}}}",
            //     "Times Used": "0",
            //     "Created DateTime": "2020-01-09 19:45:55",
            //     "Created By": "d0lph",
            //     "Is Active": 1,
            //     "Listener Details": "{\"SRVPORT\":\"80\"}",
            //     "Attack Package Type": {
            //         "Id": 0,
            //         "Name": "Attack On Demand",
            //         "Description": "Requested attack intended for a single host.  Attempt a prepared package of attack techniques to test endpoint security controls."
            //     },
            //     "Attack Package Difficulty": null,
            //     "Attack Package Objective": null
            // },
            customerId: customerInView,
            id: key,
            name: attackPackage.Name,
            description: attackPackage.Description,
            os: attackPackage.Platform.Name,
            osDetailsLogo: attackPackage.Platform.Logo,
            osDetailsDescription: attackPackage.Platform.Description,

            attackTypeId: attackPackage["Attack Package Type"].Id,
            attackTypeName: attackPackage["Attack Package Type"].Name,
            attackTypeDescription: attackPackage["Attack Package Type"].Description,

            toolkitId: attackPackage.Toolkit.Id,
            toolkitName: attackPackage.Toolkit.Name,
            toolkitDescriptionShort: attackPackage.Toolkit["Description Short"],
            toolkitDescriptionLong: attackPackage.Toolkit["Description Long"],
            url: attackPackage.Url,
        }
    )
  }) : null;

    const tableDataAsArray = () => {
        // console.log("Creating humansTableData as array from humanTableData ", tableData);
        let arr=[];
        for (let ob in tableData) {
            // console.log("ob is ", tableData[ob])
            arr.push(tableData[ob]);
        }
        // console.log("resulting array ", arr);
        return arr;
    }

    const calcProgressValue = () => {

        return !loadingAttackPackages ? 100 : 0;
    }

    const calcBufferValue = () => {
        return !loadingAttackPackages ? 100 : 50;
    }

    const calcLoadingState = () => {
        return loadingAttackPackages || loadingCustomers || !customer;
    }

    return (
        <div >
            <BBDataTable
                columns={userTableHeadings}
                rows={tableData ? tableDataAsArray() : []}
                totalRows={attackPackages ? Object.keys(attackPackages) : 0}
                progressValue={calcProgressValue()}
                bufferValue={calcBufferValue()}
                title={title}
                loading={calcLoadingState()}
                rowsPerPageOptions = {[6]}
                defaultPageSize = {6}
                numSkeletonRows = {6}
                height={"475px"}
                defaultSortModel = {[
                    {
                        field: 'attackTypeName',
                        sort: 'asc',
                    },
                    {
                        field: 'name',
                        sort: 'asc',
                    },

                ]}
                />
        </div>
    );



}
TableContainer.propTypes = {
    customerId: PropTypes.string,
};

export default TableContainer